class OnimaskHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
    if (this.slides.length < 2) return;

    this.current = 0;
    this.intervalMs = Number(this.dataset.interval || 6000);
    this.timer = null;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goTo(index));
    });

    this.start();
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
  }

  goTo(index) {
    this.slides[this.current]?.classList.remove('is-active');
    this.dots[this.current]?.classList.remove('is-active');
    this.current = index;
    this.slides[this.current]?.classList.add('is-active');
    this.dots[this.current]?.classList.add('is-active');
  }

  next() {
    this.goTo((this.current + 1) % this.slides.length);
  }

  start() {
    this.stop();
    this.timer = window.setInterval(() => this.next(), this.intervalMs);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
  }
}

customElements.define('onimask-hero', OnimaskHero);
